import app from 'app';
import productMain from './product/product-main';
import productRecommendations from './product/recommendations';

app.add({
  productMain,
  productRecommendations,
});
app.mount();
